<h2 class="detail-header">Workflow settings</h2>

<nuc-tab-bar [tabs]="tabBarItems" [(activeTab)]="selectedTab"></nuc-tab-bar>
<hr class="full-width-tab-hr">

<workflow-configuration-detail-property-component [propertyMetadata]="propertyMetadata"></workflow-configuration-detail-property-component>
